var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"resend-otp resend_otp",class:_vm.remaningSecond ? 'disable-otp' : '',on:{"click":_vm.sendOtpCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }